import { render, staticRenderFns } from "./EditProposedRecommendations.vue?vue&type=template&id=81560e8a&scoped=true"
import script from "./EditProposedRecommendations.vue?vue&type=script&lang=js"
export * from "./EditProposedRecommendations.vue?vue&type=script&lang=js"
import style0 from "./EditProposedRecommendations.vue?vue&type=style&index=0&id=81560e8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81560e8a",
  null
  
)

export default component.exports